import { CreativeRepository, BannerRepository } from '.'

export const CreativeTypes = {
  BANNER: 'banner',
  VIDEO: 'video',
  AUDIO: 'audio',
  INFEED: 'in feed',
  THREE_PAS: 'three pas',
}

export const AnAuditStatuses = {
  NO_AUDIT: 'no audit',
  PENDING: 'pending',
  AUDITED: 'audited',
  REJECTED: 'rejected',
}

export const SmartNewsAuditStatuses = {
  PENDING: 'pending',
  APPROVE: 'approve',
  REJECT: 'reject',
}

export const AnGoogleStatuses = {
  NO_AUDIT: 'no audit',
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
}

export class AbstractCreativeModel {
  /**
   * Xandrの審査が通っているがGoogleの審査が却下された
   */
  get hasNotice() {
    return (
      this.anAuditStatus === AnAuditStatuses.AUDITED &&
      this.anGoogleStatus === AnGoogleStatuses.REJECTED
    )
  }

  /**
   * Xandrの審査が却下された
   */
  get hasWarning() {
    return this.anAuditStatus === AnAuditStatuses.REJECTED
  }
}

/**
 * リスト表示に使う
 */
export class CreativeSummaryModel extends AbstractCreativeModel {
  constructor(data = {}) {
    super()
    const {
      id,
      ownerProfileId,
      name,
      status,
      isExpired,
      creativeType,
      creativeFolderId,
      anAuditStatus,
      anGoogleStatus,
    } = data

    this.id = id
    this.ownerProfileId = ownerProfileId
    this.name = name
    this.status = status
    this.isExpired = isExpired
    this.creativeType = creativeType
    this.creativeFolderId = creativeFolderId
    this.anAuditStatus = anAuditStatus
    this.anGoogleStatus = anGoogleStatus
  }

  static assign(data) {
    return new CreativeSummaryModel(data)
  }

  get isActive() {
    return this.status === 'active'
  }

  get isRejected() {
    return this.anAuditStatus === AnAuditStatuses.REJECTED
  }

  get size() {
    if (this.width == null || this.height == null) return undefined
    return this.width * this.height
  }

  async getDetail() {
    switch (this.creativeType) {
      case CreativeTypes.BANNER: {
        return await BannerRepository.get(this.id)
      }
      case CreativeTypes.INFEED: {
        return await CreativeRepository.getInfeed(this.id)
      }
      default: {
        throw new Error(
          `取得できない種別です：${this.creativeType}(ID: ${this.id})`,
        )
      }
    }
  }
}

/**
 * STEP1. クリエイティブ新規登録フォーム
 * - クリエイティブ種別選択
 */
export class NewCreativeFormModel {
  constructor() {
    this.creativeType = null
  }

  get isValid() {
    return this.creativeType != null
  }
}

/**
 * STEP2. クリエイティブフォルダ選択フォーム
 * - フォルダ選択
 */
export class SelectCreativeFolderFormModel {
  constructor({ creativeFolder }) {
    this.creativeFolder = creativeFolder || null
  }

  get isValid() {
    return this.creativeFolder != null
  }
}
